module.exports = __webpack_public_path__ + "img/card7.9ed009d5.png";